<template>
  <EquipmentRow
    :key="`${equipment.r_step_down_transformer?.id}`"
    data-cy="down-trans-row"
  >
    <template #left></template>
    <template #default="{ toggle }">
      <AddRemoveButtons
        data-cy="down-trans-row-add-remove-buttons"
        :hide-add-below="true"
        :disable-remove="!equipment.down_trans_id"
        @remove="
          equipmentForm.update({
            r_step_down_transformer: null,
            down_trans_id: null
          })
        "
      >
        <template #middle-content>
          <EquipmentPanel
            class="flex-grow-1"
            data-cy="down-trans-row-equipment-panel"
            :rule-names="['down_trans_obsolete']"
            @toggle="toggle"
          >
            <template #header>
              <span>Step Down Transformer</span>
            </template>
            <template v-if="equipment.r_step_down_transformer" #trigger>
              {{ computeDownTransLabel(equipment.r_step_down_transformer) }}
            </template>
          </EquipmentPanel>
        </template>
      </AddRemoveButtons>
    </template>
    <template #expand="{ toggle }">
      <StepDownTransformerSearchView
        :is-admin="false"
        data-cy="down-trans-row-step-down-transformer-search-view"
        @select="handleStepDownTransformerSelect($event, toggle)"
      />
    </template>
    <template #right>
      <div class="flex flex-column" data-cy="down-trans-row-right">
        <span class="body-4 mb-1">Tap Range</span>
        <span class="numeral-2">
          {{ equipment.r_step_down_transformer?.min_secondary_voltage }}
          -
          {{ equipment.r_step_down_transformer?.max_secondary_voltage }}
        </span>
      </div>
    </template>
  </EquipmentRow>
</template>

<script setup lang="ts">
import { computed, provide } from "vue";
import EquipmentRow from "@/components/scenarios/EquipmentRow.vue";
import EquipmentPanel from "@/components/scenarios/EquipmentPanel.vue";
import StepDownTransformerSearchView from "./StepDownTransformerSearchView.vue";
import { computeDownTransLabel } from "@/models/equipment/step_down_transformer/properties";
import { injectStrict } from "@/utils/utils";
import { equipmentFormKey } from "@/composables/scenarioDetailProvider/scenarioDetailProviderKeys";
import AddRemoveButtons from "@/components/AddRemoveButtons.vue";
import type { Step_Down_Transformers } from "gql/api";

const equipmentForm = injectStrict(equipmentFormKey);
const equipment = computed(() => equipmentForm.data.value);

provide(
  "selected-equipment-id",
  computed(() => equipment.value.r_step_down_transformer?.id)
);

function handleStepDownTransformerSelect(
  stepDownTransformer: Step_Down_Transformers,
  toggle: () => void
) {
  toggle();
  equipmentForm.update({
    r_step_down_transformer: stepDownTransformer,
    down_trans_id: stepDownTransformer?.id
  });
}
</script>
